const OemBadge = () => (
  <div className="px-3 py-1 rounded-md text-xs text-white bg-blue-700">OEM</div>
)

export default OemBadge
